// Client wrappers for the Phase-5 Platform Admin callables:
// staff access, session control, GDPR purge, platform config.
import { call } from './callable';


export type StaffRole = 'superadmin' | 'support' | 'finance';

export interface StaffMember {
  uid: string;
  email: string | null;
  role: StaffRole;
  grantedBy: string | null;
  grantedAt: number;
  isRoot: boolean;
  claimOk: boolean;
  disabled: boolean;
  lastSignIn: string | null;
}

const padminAuditC = call<any, any>('padminAudit');

export const listStaff = async () => (await padminAuditC({ action: 'listStaff' })).data;
export const grantStaff = async (p: { email: string; role: StaffRole; reason: string }) => (await padminAuditC({ action: 'grantStaff', ...p })).data;
export const revokeStaff = async (uid: string, reason: string) => (await padminAuditC({ action: 'revokeStaff', uid, reason })).data;

// ── sessions / account state ─────────────────────────────────────────────────
export const revokeUserSessions = async (uid: string, reason: string) => (await padminAuditC({ action: 'revokeUserSessions', uid, reason })).data;
export const setUserDisabled = async (p: { uid: string; disabled: boolean; reason: string }) => (await padminAuditC({ action: 'setUserDisabled', ...p })).data;

// ── GDPR purge ───────────────────────────────────────────────────────────────
export interface PurgePreview {
  tenantId: string;
  tenantName: string;
  counts: Record<string, number>;
  memberUids: string[];
  total: number;
}

export const previewPurge = async (tenantId: string) => (await padminAuditC({ action: 'previewPurge', tenantId })).data;
export const purgeTenant = async (p: { tenantId: string; confirmName: string; reason: string }) => (await padminAuditC({ action: 'purgeTenant', ...p })).data;

// ── platform config ──────────────────────────────────────────────────────────
export interface TaxConfig {
  enabled: boolean;
  /** ISO-3166 alpha-2 → percent. */
  rates: Record<string, number>;
  defaultRatePct: number;
  label: string;
  registrationNumber: string;
}

export interface PlatformConfig {
  flags: Record<string, boolean>;
  tax: TaxConfig;
  retention: { enabled: boolean; conversationDays: number };
  announcement: { enabled: boolean; text: string; textAr: string };
  status: { stuckSending: number; overdueScheduled: number; staffCount: number };
}

export interface PlatformConfigPatch {
  flags?: Record<string, boolean>;
  tax?: TaxConfig;
  retention?: { enabled: boolean; conversationDays: number };
  announcement?: { enabled: boolean; text: string; textAr: string };
  reason: string;
}

export const getPlatformConfig = async () => (await padminAuditC({ action: 'getPlatformConfig' })).data;
export const setPlatformConfig = async (p: PlatformConfigPatch) => (await padminAuditC({ action: 'setPlatformConfig', ...p })).data;
